import { LockKey } from "@phosphor-icons/react";
import "./access.css";

export const NO_ACCESS_DEFAULT_MESSAGE =
  "אין לך הרשאה לצפות בחלק זה. לפתיחת הגישה יש לפנות למנהל/ת הקליניקה.";

/**
 * Full-panel "no permission" empty state (multi-clinic v2 §2.6).
 * Never redirect silently — render this instead.
 *
 * @param {string} [message] overrides the default sentence
 * @param {string} [reason]  optional second line, e.g. "הרשאה נדרשת: צפייה ביומן הקליניקה"
 * @param {"page"|"panel"|"inline"} [size]
 */
function NoAccessState({ message = NO_ACCESS_DEFAULT_MESSAGE, reason = null, size = "panel", children = null }) {
  return (
    <div className={`ck-no-access ck-no-access-${size}`} role="status">
      <span className="ck-no-access-icon">
        <LockKey size={size === "inline" ? 18 : 26} weight="duotone" />
      </span>
      <p className="ck-no-access-message">{message}</p>
      {reason && <p className="ck-no-access-reason">{reason}</p>}
      {children}
    </div>
  );
}

export default NoAccessState;
